// extracted by mini-css-extract-plugin
module.exports = {"update":"Updates_update__1j-lY","pop":"Updates_pop__2aR-A","fade-in":"Updates_fade-in__3u-XI","float":"Updates_float__2pEZT","slide-in-fade":"Updates_slide-in-fade__2M9DK"};